// Frozen copy of main's code for the document_generation_v4_enabled / agency_brand_design_enabled flag-off path; delete with the flag.
import { Node } from '@tiptap/core';

export const SvgNode = Node.create({
  name: 'svg',

  group: 'inline',
  atom: true,
  selectable: true,
  inline: true,

  addAttributes() {
    return {
      svgContent: { default: '' },
      viewBox: { default: null },
      width: { default: null },
      height: { default: null }
    };
  },

  parseHTML() {
    return [
      {
        tag: 'svg',
        getAttrs: (element) => {
          const el = element as unknown as SVGSVGElement;
          return {
            svgContent: el.innerHTML || '',
            viewBox: el.getAttribute('viewBox'),
            width: el.getAttribute('width'),
            height: el.getAttribute('height')
          };
        }
      }
    ];
  },

  renderHTML({ node }) {
    const el = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    el.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    const viewBox = node.attrs.viewBox;
    const width = node.attrs.width;
    const height = node.attrs.height;
    if (viewBox) el.setAttribute('viewBox', viewBox);
    if (width) el.setAttribute('width', width);
    if (height) el.setAttribute('height', height);
    el.innerHTML = node.attrs.svgContent ?? '';
    return el;
  },

  addNodeView() {
    return ({ node }) => {
      const wrapper = document.createElement('span');
      wrapper.style.display = 'inline-block';
      wrapper.style.verticalAlign = 'middle';
      wrapper.style.lineHeight = '0';
      const el = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      el.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      const viewBox = node.attrs.viewBox;
      const width = node.attrs.width;
      const height = node.attrs.height;
      if (viewBox) el.setAttribute('viewBox', viewBox);
      if (width) el.setAttribute('width', width);
      if (height) el.setAttribute('height', height);
      el.innerHTML = node.attrs.svgContent ?? '';
      el.setAttribute('contenteditable', 'false');
      wrapper.appendChild(el);
      return {
        dom: wrapper,
        update: (updatedNode) => {
          if (updatedNode.type !== this.type) return false;
          el.innerHTML = updatedNode.attrs.svgContent ?? '';
          if (updatedNode.attrs.viewBox) el.setAttribute('viewBox', updatedNode.attrs.viewBox);
          else el.removeAttribute('viewBox');
          if (updatedNode.attrs.width) el.setAttribute('width', updatedNode.attrs.width);
          else el.removeAttribute('width');
          if (updatedNode.attrs.height) el.setAttribute('height', updatedNode.attrs.height);
          else el.removeAttribute('height');
          return true;
        }
      };
    };
  }
});
